module.exports = __webpack_public_path__ + "4e958e3437d48d4b769d4f19248f0a3a.pdf";